import React from 'react'
import { 
    Form, FormCell, Switch, CellBody, CellFooter, Cell, Cells, Input, Button, Toast,
    Dialog, Toptips
} from 'react-weui'
import { browserHistory } from 'react-router'
import axios from 'axios'
import qs from 'qs'


class ScheduleMyListSettingPage extends React.Component {
    constructor (props) {
        super(props)
        this.state = {
            isRemind: false,
            time: '00:00',
            isPending: false,
            isShowSuccessDialog: false,
            tip: {
                isShow: false,
                text: '',
                type: 'warn',
            },
        }
    }
    componentDidMount () {
        document.title = '我的打卡'
        axios.get('/api/schedule/notify/info')
            .then(res => {
                const data = res.data.data
                this.setState({
                    isRemind: data.notify.accept_notify,
                    time: data.notify.notify_time,
                })
            })
    }
    showTip (text, type = 'warn') {
        this.setState({
            tip: { isShow: true, text, type },
        })
        setTimeout(() => {
            this.setState({
                tip: { isShow: false },
            })
        }, 2000)
    }
    submit () {
        if (this.state.isRemind) {
            if (!this.state.time) {
                return this.showTip('请设置提醒时间')
            }
            if (this.state.time >= '00:00' && this.state.time <= '05:59') {
                return this.setState({ isShowTimeErr: true })
            }
        }
        this.setState({ isPending: true })
        axios.post('/api/schedule/notify/setting', qs.stringify({
            accept_notify: this.state.isRemind,
            notify_time: this.state.time || '00:00',
        }))
            .then(res => {
                this.setState({ isPending: false })
                if (res.data.code !== 0) {
                    this.setState({
                        isShowErrDialog: true,
                        errMsg: res.data.msg,
                    })
                    return
                }
                this.setState({ isShowSuccessDialog: true })
            })
    }
    render() {
        return (
            <div className="schedule-my-list-setting-page wk-page">
                <Form className='margin-bottom margin-top'>
                    <FormCell switch>
                        <CellBody>
                            开启打卡提醒
                            <div className="inner-intro">开启提醒，活动期间每天都会收到公众号推送通知</div>
                        </CellBody>
                        <CellFooter>
                            <Switch onChange={e => this.setState({ isRemind: e.target.checked })} checked={this.state.isRemind} />
                        </CellFooter>
                    </FormCell>
                </Form>
                {/* <Form> */}
                    <Cells>
                        <Cell className='time-cell' href="javascript:;" access>
                            <CellBody>
                                设置每日提醒时间
                            </CellBody>
                            <CellFooter>
                                <Input type="time" value={this.state.time} onChange={e => this.setState({ time: e.target.value })} />
                            </CellFooter>
                        </Cell>
                    </Cells>
                {/* </Form> */}
                <div className="intro">
                    <p>1. 平台0:00-5:59为系统维护时间，不开放推送功能，设置提醒时请避开此段时间</p>
                    <p>2. 此时间为北京时间，请国外用户注意与本地时区的差异</p>
                </div>
                <div className="wk-btn-90">
                    <Button onClick={e => this.submit()}>确定</Button>
                </div>
                <Toast icon="loading" show={this.state.isPending}></Toast>
                <Dialog type="ios" title='' buttons={[
                    { label: '确定', onClick: () => browserHistory.go(-1) }
                ]} show={this.state.isShowSuccessDialog}>
                    修改成功
                </Dialog>
                <Dialog type="ios" title='温馨提示' buttons={[
                    { label: '我知道了', onClick: () => this.setState({ isShowTimeErr: false }) }
                ]} show={this.state.isShowTimeErr}>
                    <div style={{textAlign: 'left'}}>
                        平台0:00-5:59为系统维护时间，不开放推送功能，设置提醒时请避开此段时间
                    </div>
                </Dialog>
                <Toptips type={this.state.tip.type} show={this.state.tip.isShow}>{this.state.tip.text}</Toptips>
            </div>
        )
    }
}

export default ScheduleMyListSettingPage


// WEBPACK FOOTER //
// ./src/pages/schedule/ScheduleMyListSettingPage.js